import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.close = this.close.bind(this)
    this.closeFromOutside = this.closeFromOutside.bind(this)
    document.addEventListener("click", this.closeFromOutside)
    document.addEventListener("keydown", this.close)
  }

  disconnect() {
    document.removeEventListener("click", this.closeFromOutside)
    document.removeEventListener("keydown", this.close)
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen) {
      this.hide()
    } else {
      this.show()
    }
  }

  close(event) {
    if (event.type === "keydown" && event.key !== "Escape") return
    if (!this.isOpen) return

    this.hide()

    if (event.type === "keydown") {
      this.buttonTarget.focus()
    }
  }

  closeFromOutside(event) {
    if (this.element.contains(event.target)) return
    this.hide()
  }

  closeAfterSelection(event) {
    if (!event.target.closest("a, button")) return
    this.hide()
  }

  show() {
    this.menuTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.element.classList.add("is-open")
  }

  hide() {
    if (!this.hasMenuTarget || !this.hasButtonTarget) return

    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.element.classList.remove("is-open")
  }

  get isOpen() {
    return this.hasMenuTarget && !this.menuTarget.hidden
  }
}
